export class CotizacionServicioDTO {
    constructor(
        public idServicioSolicitudCotizacion: number,
        public descripcionTrabajo: string,
        public tiempoTrabajo: number,
        public valor: number
    ) {
        this.idServicioSolicitudCotizacion = idServicioSolicitudCotizacion;
        this.descripcionTrabajo = descripcionTrabajo;
        this.tiempoTrabajo = tiempoTrabajo;
        this.valor = valor;
    }
}
